export default __webpack_public_path__ + "static/media/01-small.5133abec.png";